module.exports = __webpack_public_path__ + "media/correct.6c55bcc4.mp3";